/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum NewbornInvestigationPeriod {
    AT_FORTY_EIGHT_HOURS = 'atFortyEightHours',
    AT_SIX_TO_EIGHT_WEEKS = 'atSixToEightWeeks',
    AT_NINE_MONTHS = 'atNineMonths',
}
